import { Router } from 'preact-router';
import Home from '@pages/index';
import Download from './pages/DownLoad';
import LogOut from '@pages/login/loginout';
import AndroidDownload from '@pages/Download/mobile';
import OtherPlatformsLogin from '@pages/OtherPlatformsLogin';
const App = () => (
	<div id="app">
		<main>
			<Router>
				<Home path="/" exact/>
				<Download path="/downloadapp/:id" />
				<AndroidDownload path='/Download/mobile/:id'/>
				<LogOut path="/Login/loginout" />
				<OtherPlatformsLogin path='OtherPlatformsLogin'/>
			</Router>
		</main>
	</div>
);

export default (App);
